import React, { useEffect, useState, useContext } from "react";
import { apiGetRequest } from "helpers/Requests";
import { useParams, useNavigate, useLocation } from "react-router";
import { LoginContext } from "helpers/LoginContext";
import {
  getNameProfile,
  selectedTabState,
  getFormSubTabForParticipantProfile,
  getUrlRole,
} from "Utils/utils";
import { Link } from "react-router-dom";
import { USER_ROLE } from "Constants/constant";
import SectionInputFields from "components/DynamicForms/SectionAndSubSectionFields/SectionsInputFields";
import HumanBodyModal from "components/Modals/HumanBody/HumanBodyModal";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import SideBar from "components/common/SideBar/SideBarNew";
import AlertModal from "components/Modals/alertModal";
import { roleAccess } from "helpers/RolesPermission";
import {
  FormPageBreadcrumb,
  FormPageHeader,
  FormMetaStrip,
  FormSectionList,
  FormSectionNav,
  FormPageLoader,
  FormPageShell,
  FormViewPage,
  buildSubmittedFormMetaItems,
} from "../shared/FormPageLayout";

const SubmittedSingleFormViewHRM = () => {
  const { slug: uuid, parentSlug } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const { sideBarPadding } = useContext(LoginContext);
  const [viewFormData, setViewFormData] = useState(null);
  const [signatures, setSignatures] = useState(null);
  const [formData, setFormData] = useState(null);
  const [openBodyModal, setOpenBodyModal] = useState(false);
  const [selectedBody, setSelectedBody] = useState("");
  const [selectedLegal, setSelectedLegal] = useState(null);
  const [request, setRequest] = useState({
    isRequested: false,
    isSuccess: false,
    isFailed: false,
  });

  const fetchFormTempletes = async () => {
    setRequest((prev) => ({ ...prev, isRequested: true }));
    try {
      const res = await apiGetRequest(
        `${getUrlRole()}/employee/submitted-forms-view?form_id=${uuid}`
      );
      if (res.status !== 200) {
        setRequest((prev) => ({ ...prev, isRequested: false, isFailed: true }));
      } else {
        setRequest((prev) => ({ ...prev, isRequested: false, isSuccess: true }));
        setFormData(res?.data?.submitted_form);
        if (res?.data?.submitted_form?.template?.length > 0) {
          setViewFormData(JSON.parse(res?.data?.submitted_form?.template));
          setSignatures(JSON.parse(res?.data?.submitted_form?.signatures));
        }
      }
    } catch (err) {
      setRequest((prev) => ({ ...prev, isRequested: false, isFailed: true }));
    }
  };

  useEffect(() => {
    fetchFormTempletes();
    return () => {
      if (getFormSubTabForParticipantProfile(parentSlug)) {
        selectedTabState.save(
          JSON.stringify(getFormSubTabForParticipantProfile(parentSlug))
        );
      }
    };
  }, []);

  const handleImageError = (e, fname, lname) => {
    e.target.src = getNameProfile(fname, lname);
  };

  const getEditLink = () => {
    if (!formData?.can_edit || roleAccess([USER_ROLE.Sp_Standard_User])) {
      return null;
    }
    if (formData.is_complete) {
      return {
        to: `/worker-profile/${parentSlug}/${uuid}/update`,
        state: { particpantUuid: state?.particpantUuid },
        label: "Edit Submission",
      };
    }
    return {
      to: `/view-template/hrm/${state?.particpantUuid}/${parentSlug}/${uuid}/${window.btoa(
        encodeURIComponent("false")
      )}`,
      label: "Complete Submission",
    };
  };

  const editLink = getEditLink();

  return (
    <>
      <div className="min-h-screen">
        <section className="print:hidden">
          <SideBar />
        </section>
        {request.isSuccess && viewFormData && formData ? (
          <FormViewPage
            sideBarPadding={sideBarPadding}
            header={
              <FormPageHeader
                title={formData.title}
                role="hrm"
                sectionCount={viewFormData.length}
                status={formData.is_complete ? "complete" : "in-progress"}
                breadcrumb={
                  <FormPageBreadcrumb
                    formData={formData}
                    formTitle={formData.title}
                    parentSlug={parentSlug}
                    routeRole='hrm'
                    participantUuid={
                      formData?.participant_uuid ??
                      formData?.worker_uuid ??
                      state?.particpantUuid
                    }
                  />
                }
                onPrint={() => {
                  window.scrollTo(0, 0);
                  window.print();
                }}
                onBack={() => navigate(-1)}
                editLink={editLink}
                showNotifications={false}
              />
            }
          >
            <FormMetaStrip
              className="is-compact"
              items={buildSubmittedFormMetaItems({
                formData,
                routeRole: "hrm",
                handleImageError,
              })}
            />
            {viewFormData.length > 1 && (
              <FormSectionNav sections={viewFormData} />
            )}
            <FormSectionList
              sections={viewFormData}
              formData={formData}
              renderFields={(section, index) => (
                <SectionInputFields
                  key={`${index}-${section?.section_title}`}
                  isViewable={true}
                  section={section}
                  index={index}
                  templateForm={formData}
                  participant={formData?.participant}
                  signatures={signatures ?? []}
                  setSelectedBody={setSelectedBody}
                  setOpenBodyModal={setOpenBodyModal}
                  setSelectedLegal={setSelectedLegal}
                />
              )}
            />
            {openBodyModal && (
              <HumanBodyModal
                view={true}
                selectedValue={selectedBody}
                isOpen={openBodyModal}
                closeModal={() => setOpenBodyModal(false)}
              />
            )}
            {selectedLegal && (
              <AlertModal
                show={selectedLegal !== null}
                handleClose={() => setSelectedLegal(null)}
              >
                {selectedLegal}
              </AlertModal>
            )}
          </FormViewPage>
        ) : (
          <FormPageShell sideBarPadding={sideBarPadding}>
            <FormPageLoader />
          </FormPageShell>
        )}
      </div>
    </>
  );
};

export default SubmittedSingleFormViewHRM;
